<template>
   <div class="checkout-ssrs" :id="`checkout-ssrs-${flightIdentifier}`">
      <div class="ssrs-header">
         <ul>
            <li
               v-for="(column, index) in SSRs.columns"
               :key="index"
               :class="[column.identifier, { 'hover-remove': hoverColumn[column.identifier] }]"
               @mouseenter="setHoverColumn(column.identifier)"
               @mouseleave="clearHoverColumn(column.identifier)"
               @click="clearColumn(column.identifier, flightIdentifier)">
               <img :src="require(`@/assets/images/checkoutSsrs/${column.identifier}.png`)" alt="" class="light-mode-ssr-image" />
               <img :src="require(`@/assets/images/checkoutSsrs/dark_${column.identifier}.png`)" alt="" class="dark-mode-ssr-image" />
               <span class="ssr-header-remove"></span>
               <span class="ssr-header-name">{{ $t(`CheckoutSSRs_lbl${column.label}`) }} </span>
               <!-- <span class="ssr-header-name">{{ column.label }}</span> -->
            </li>
         </ul>
      </div>
      <div class="passengers">
         <div class="passenger" :class="{ 'last-passenger': paxIndex === SSRs.paxes.length - 1 }" v-for="(pax, paxIndex) in SSRs.paxes" :key="paxIndex">
            <div class="passenger-info">
               <span class="passenger-name">{{ pax.label }}</span>
               <span class="passenger-type">{{ pax.type }}</span>
            </div>
            <div class="segments">
               <div class="segment" v-for="(segment, segmentIndex) in pax.segments" :key="segmentIndex">
                  <div class="segment-route">
                     <span class="route-from">{{ segment.departureAirportCode }}</span>
                     <img :src="`https://cdn.dev.reisetech.io/airline_34x34/${segment.airlineCode}.svg`" alt="" class="route-airline" />
                     <span class="route-to">{{ segment.arrivalAirportCode }}</span>
                  </div>
                  <div class="ssr-list">
                     <div class="ssr-item" :class="ssrType" v-for="(ssr, ssrType) in segment.ssrs" :key="ssrType">
                        <!-- Seçilmiş durum -->

                        <template v-if="ssr.selected">
                           <button
                              class="ssr-button has-selection"
                              :class="{ 'free-conjuncted': ssr.isFreeConjuncted, 'in-basket': ssr.inBasket, 'remove-preview': ssr.isFreeConjuncted && isConjunctedHovered(pax.id, ssrType) }"
                              @click="ssr.isFreeConjuncted ? null : clearSSR(ssr, ssrType, pax.id, segmentIndex + 1, flightIdentifier)"
                              @mouseenter="!ssr.isFreeConjuncted && ssr.isConjunctedMaster ? setHoverRemove(pax.id, ssrType) : null"
                              @mouseleave="!ssr.isFreeConjuncted && ssr.isConjunctedMaster ? clearHoverRemove(pax.id, ssrType) : null"
                              :disabled="ssr.isFreeConjuncted">
                              <span v-if="ssr.name" class="ssr-name">{{ ssr.label }} </span>
                              <template v-if="typeof ssr.price == 'number'">
                                 <span class="ssr-price" v-if="ssr.price == 0">{{ $t("CheckoutSSRs_lblFree") }}</span>
                                 <span class="ssr-price" v-else>{{ ssr.price | price }}</span>
                              </template>

                              <span v-if="ssr.isFreeConjuncted" class="ssr-free-label">{{ $t("CheckoutSSRs_lblFree") }}</span>

                              <span v-else class="ssr-close"></span>
                           </button>
                        </template>

                        <template v-else>
                           <div class="ssr-dropdown-wrapper" v-click-outside="closeAllDropdowns">
                              <button
                                 class="ssr-button"
                                 :class="{ 'making-selection': ssr.makingSelection, 'btn-disabled': ssr.options.length == 0, 'is-conjucted': ssr.isConjuncted }"
                                 @click.stop="ssr.makingSelection = !ssr.makingSelection">
                                 <template v-if="!ssr.isConjuncted && ssr.options.length != 0">
                                    <span v-if="hoverColumn[ssrType]" class="ssr-close column-remove-icon"></span>
                                    <span v-else class="ssr-add"></span>
                                 </template>
                              </button>

                              <template v-if="ssr.makingSelection">
                                 <ul class="ssr-dropdown">
                                    <li v-for="(option, optionIndex) in ssr.options" :key="optionIndex" @click="selectSSR(ssr, option, ssrType, pax.id, segmentIndex + 1, flightIdentifier)">
                                       <span class="option-name">{{ option.label }}</span>

                                       <span class="option-price">
                                          <template v-if="ssrType === 'seat'">
                                             <i> {{ option.value }} </i>|
                                          </template>
                                          {{ option.price | price }}
                                       </span>
                                    </li>
                                 </ul>
                              </template>
                           </div>
                        </template>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- Toplam Row -->
         <div class="total-row">
            <div class="total-label">
               {{ $t("CheckoutSSRs_lblTotal") }}
               <!-- {{ $t("CheckoutSSRs_lblTotal") }} -->
               <!-- <i
                  :class="['gts-icon', showSegmentBreakdown ? 'icon-eye' : 'icon-eye-closed']"
                  @click="showSegmentBreakdown = !showSegmentBreakdown"
                  :title="showSegmentBreakdown ? $t('CheckoutSSRs_lblShowTotal') : $t('CheckoutSSRs_lblShowBySegment')"></i> -->
            </div>
            <div class="total-segments">
               <!-- Birleşik Toplam -->
               <div v-if="!showSegmentBreakdown" class="total-segment combined">
                  <div class="segment-route combined-label"></div>
                  <div class="ssr-totals">
                     <div class="ssr-total" :class="column.identifier" v-for="(column, index) in SSRs.columns" :key="index">
                        <template v-if="combinedTotals[column.identifier]?.count > 0">
                           <span class="total-count">{{ combinedTotals[column.identifier].count }}xAS</span>
                           <span class="total-price">{{ combinedTotals[column.identifier].price | price }}</span>
                        </template>
                        <template v-else>
                           <span class="total-empty">-</span>
                        </template>
                     </div>
                  </div>
               </div>

               <!-- Segment Bazlı Toplam -->
               <template v-else>
                  <div class="total-segment" v-for="(segment, segmentIndex) in SSRs.paxes[0].segments" :key="segmentIndex">
                     <div class="segment-route">
                        <span class="route-from">{{ segment.departureAirportCode }}</span>
                        <img :src="`https://cdn.dev.reisetech.io/airline_34x34/${segment.airlineCode}.svg`" alt="" class="route-airline" />
                        <span class="route-to">{{ segment.arrivalAirportCode }}</span>
                     </div>
                     <div class="ssr-totals">
                        <div class="ssr-total" :class="ssrType" v-for="(ssr, ssrType) in segment.ssrs" :key="ssrType">
                           <template v-if="ssrTotals[`${ssrType}_${segmentIndex + 1}`]?.count > 0">
                              <span class="total-count">{{ ssrTotals[`${ssrType}_${segmentIndex + 1}`].count }}x</span>
                              <span class="total-price">{{ ssrTotals[`${ssrType}_${segmentIndex + 1}`].price | price }}</span>
                           </template>
                           <template v-else>
                              <span class="total-empty"></span>
                           </template>
                        </div>
                     </div>
                  </div>
               </template>
            </div>
         </div>

         <ul class="checkout-ssr-notes" v-if="ssrNotes.length">
            <li v-for="(note, index) in ssrNotes" :key="index">
               <template v-if="note.label">
                  <strong v-if="false">{{ note.label }}:</strong> {{ note.text }}
               </template>
               <template v-else>{{ note.text }}</template>
            </li>
         </ul>
      </div>

      <div class="update-basket-wrapper">
         <UIButton className="gradient_blue_pink" :text="$t('CheckoutSSRs_btnUpdateBasket')" @click.native="handlerUpdateBasket" />
      </div>
   </div>
</template>

<script>
import checkoutSSRsMixin from "@/mixins/checkoutSSRsMixin";
import UIButton from "@/components/unitary/Button.vue";
export default {
   name: "CheckoutSsr",
   mixins: [checkoutSSRsMixin],
   components: {
      UIButton,
   },
   props: {
      data: Object,
      flightIdentifier: String,
   },

   data() {
      return {
         showSegmentBreakdown: true,
      };
   },

   mounted() {
      this.syncInitialSelections();
   },

   methods: {
      syncInitialSelections() {
         this.SSRs.paxes.forEach((pax) => {
            pax.segments.forEach((segment) => {
               Object.entries(segment.ssrs).forEach(([ssrType, ssr]) => {
                  if (ssr.selected && !ssr.isFreeConjuncted) {
                     this.$store.commit("flight/updatePaxCheckoutSSR", {
                        paxId: pax.id,
                        ssrType,
                        route: `${segment.departureAirportCode}-${segment.arrivalAirportCode}`,
                        flightIdentifier: this.flightIdentifier,
                        status: true,
                     });
                  }
               });
            });
         });
      },
   },
};
</script>

<style>
.dark-theme .ssrs-header .dark-mode-ssr-image {
   mix-blend-mode: normal !important;
}
.dark-theme .ssrs-header .light-mode-ssr-image,
.light-theme .ssrs-header .dark-mode-ssr-image {
   display: none !important;
}

.light-theme .ssrs-header .light-mode-ssr-image {
   mix-blend-mode: multiply !important;
}

.dark-theme .ssr-add {
   background-color: var(--gray-0) !important;
}
.dark-theme .ssr-name {
   color: var(--blue-300) !important;
}
.dark-theme .ssr-price,
.dark-theme .ssr-free-label {
   color: var(--blue-400) !important;
}

.dark-theme .in-basket .ssr-name {
   color: var(--green-300) !important;
}
.dark-theme .in-basket .ssr-price,
.dark-theme .in-basket .ssr-free-label {
   color: var(--green-400) !important;
}
</style>

<style lang="scss" scoped>
// --- Variables ---
$widthOne: 120px;
$widthTwo: 140px;
$widthButton: 146px;
$widthThree: $widthButton + 16px;
$widthButtonMeal: 200px;
$widthThreeMeal: $widthButtonMeal + 16px;

// --- Mixins ---
@mixin segment-route-base {
   display: flex;
   align-items: center;
   gap: 0.5rem;
   width: $widthTwo;
   border-right: 1px solid var(--gray-200);

   .route-from,
   .route-to {
      font-size: 16px;
      font-weight: 500;
      min-width: 40px;
   }

   .route-from {
      text-align: right;
   }

   .route-airline {
      width: 24px;
      height: 24px;
   }
}

@mixin conjuncted-pip($bg-color) {
   &::before,
   &::after {
      content: "";
      position: absolute;
      top: -10px;
      display: block;
      width: 16px;
      height: 10px;
      background-color: $bg-color;
   }

   &::before {
      transform: translateX(-16px);
   }

   &::after {
      transform: translateX(16px);
   }
}

.checkout-ssr-notes {
   display: flex;
   flex-direction: column;
   background-color: var(--yellow-100);
   border: 1.5px solid var(--yellow-300);
   padding: 0.5rem 1rem;
   border-radius: 1rem;
   width: 100%;
   margin-top: 0.5rem;
   margin-bottom: 0.5rem;

   li {
      font-size: var(--small);
      strong {
         font-weight: 500;
      }
   }
}
// --- Component ---
.update-basket-wrapper {
   display: flex;
   // margin-top: 1rem;
}

.checkout-ssrs {
   // background-color: #fcfcfd;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   padding: 1rem;
   width: 100%;
   border-radius: 1rem;

   .ssrs-header {
      width: fit-content;

      ul {
         margin-left: $widthOne + $widthTwo;
         display: flex;

         li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            border: 1px solid var(--gray-200);
            border-bottom: none;
            height: 170px;
            box-sizing: border-box;
            width: $widthThree;
            position: relative;
            overflow: hidden;

            &.meal {
               width: $widthThreeMeal;

               img {
                  // transform: scale(0.8);
               }
            }
            &.cabin_bag {
               img {
                  // transform: scale(0.9);
               }
            }

            &:nth-child(odd) {
               background-color: var(--gray-100);
               // background-color: #f2f4f7;
            }

            img {
               transition: opacity 0.2s ease;
               mix-blend-mode: multiply;
            }

            .ssr-header-remove {
               display: none;
               width: 36px;
               height: 36px;
               background-color: var(--red-600);
               border-radius: 50%;
               position: relative;

               &::before,
               &::after {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  background-color: #fff;
                  border-radius: 1px;
               }

               &::before {
                  width: 16px;
                  height: 2px;
                  transform: translate(-50%, -50%) rotate(-45deg);
               }

               &::after {
                  width: 2px;
                  height: 16px;
                  transform: translate(-50%, -50%) rotate(-45deg);
               }
            }

            span {
               position: absolute;
               bottom: 0.25rem;
               font-weight: 500;
               transition: opacity 0.2s ease;
            }

            &.hover-remove {
               background-color: #fde8e8;
               cursor: pointer;

               img {
                  display: none;
               }

               .ssr-header-remove {
                  display: block;
               }

               .ssr-header-name {
                  display: none;
               }
            }
         }
      }
   }

   .passengers {
      // border: 1.5px solid var(--gray-200);
      background-color: var(--gray-0);
      border-radius: 1rem;
      width: fit-content;

      .passenger {
         display: flex;
         flex-direction: row;
         border-right: 1.5px solid var(--gray-200);
         border-left: 1.5px solid var(--gray-200);
         border-bottom: 2px dashed var(--gray-200);

         &:first-child {
            border-top-left-radius: 1rem;
            border-top: 1.5px solid var(--gray-200);
         }

         &.last-passenger {
            border-bottom: none !important;
         }

         .passenger-info {
            display: flex;
            flex-direction: column;
            padding-top: 1.95rem;
            padding-left: 1rem;
            line-height: 1.2rem;
            width: $widthOne;

            .passenger-name {
               font-size: 16px;
               font-weight: 600;
            }

            .passenger-type {
               font-size: 14px;
            }
         }
      }
   }

   .segments {
      padding: 0.25rem 0;

      .segment {
         display: flex;

         .segment-route {
            @include segment-route-base;
         }

         .ssr-list {
            display: flex;

            .ssr-item {
               border-right: 1px dotted gray;
               padding: 0.25rem 0;
               display: flex;
               max-width: $widthThree;

               &.meal {
                  max-width: $widthThreeMeal;

                  .ssr-button {
                     width: $widthButtonMeal;
                  }
               }

               &:last-child {
                  border-right: none;
               }

               .ssr-dropdown-wrapper {
                  position: relative;
               }

               .ssr-dropdown {
                  position: absolute;
                  top: calc(100% + 6px);
                  left: 50%;
                  transform: translateX(-50%);
                  background: var(--gray-0);
                  border: 1px solid var(--gray-200);
                  border-radius: 0.75rem;
                  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
                  min-width: $widthButton + 150px;
                  z-index: 10;
                  max-height: 300px;
                  overflow-y: auto;

                  li {
                     display: flex;
                     justify-content: space-between;
                     align-items: flex-start;
                     padding: 0.25rem 0.75rem;
                     cursor: pointer;
                     transition: background-color 0.15s ease;
                     border-bottom: 1px solid var(--gray-200);

                     &:hover {
                        background-color: var(--blue-50);
                     }

                     .option-name {
                        font-weight: 500;
                        font-size: 16px;
                        max-width: 150px;
                     }

                     .option-price {
                        font-size: 16px;
                        color: var(--gray-600);
                        font-weight: 600;
                        margin-right: 0.5rem;
                     }
                  }
               }

               // --- SSR Button base ---
               .ssr-button {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  width: $widthButton;
                  min-height: 68px;
                  border-radius: 1rem;
                  margin: 0 0.5rem;
                  background-color: #f2f4f7;
                  background-color: var(--gray-100);
                  line-height: 1.25rem;
                  font-weight: 600;

                  // --- Empty states ---
                  &.btn-disabled {
                     cursor: not-allowed;
                  }

                  &.is-conjucted {
                     @include conjuncted-pip(var(--gray-100));
                  }

                  &.making-selection {
                     background-color: var(--blue-100) !important;

                     .ssr-add {
                        background-color: var(--blue-600);
                     }
                  }

                  // --- Selected states ---
                  &.has-selection {
                     background-color: var(--blue-100);
                     color: var(--blue-700);
                     position: relative;

                     .ssr-name,
                     .ssr-price,
                     .ssr-close {
                        transition: opacity 0.2s ease;
                     }

                     &:not(.free-conjuncted):hover {
                        background-color: #fde8e8;
                        color: var(--red-700);

                        .ssr-name,
                        .ssr-price {
                           opacity: 0;
                        }

                        .ssr-close {
                           opacity: 1;
                        }
                     }

                     &.free-conjuncted {
                        cursor: not-allowed;
                        opacity: 0.85;

                        @include conjuncted-pip(var(--blue-100));

                        &.remove-preview {
                           .ssr-name,
                           .ssr-price,
                           .ssr-free-label {
                              opacity: 1;
                              color: var(--red-700);
                           }
                           background-color: #fde8e8;
                           color: var(--red-700);

                           @include conjuncted-pip(#fde8e8);
                        }

                        .ssr-free-label {
                           font-size: 14px;
                           font-weight: 900;
                           margin-top: 2px;
                           color: var(--blue-800);
                        }

                        .ssr-price {
                           display: none;
                        }
                     }

                     &.in-basket {
                        background-color: var(--green-100);
                        color: var(--green-700);

                        &::before,
                        &::after {
                           background-color: var(--green-100);
                        }

                        .ssr-price {
                           color: var(--green-800);
                        }
                        .ssr-free-label {
                           color: var(--green-800);
                        }

                        &:hover {
                           background-color: #fde8e8;
                           color: var(--red-700);

                           .ssr-name,
                           .ssr-price {
                              opacity: 0;
                           }

                           .ssr-close {
                              opacity: 1;
                           }
                        }
                     }
                  }

                  // --- Icon shared ---
                  .ssr-add,
                  .ssr-close {
                     width: 32px;
                     height: 32px;
                     background-color: var(--gray-600);
                     border-radius: 50%;
                     position: relative;

                     &::before,
                     &::after {
                        content: "";
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        background-color: #fff;
                        border-radius: 1px;
                     }

                     &::before {
                        width: 14px;
                        height: 2px;
                        transform: translate(-50%, -50%);
                     }

                     &::after {
                        width: 2px;
                        height: 14px;
                        transform: translate(-50%, -50%);
                     }
                  }

                  .ssr-add {
                     background-color: var(--gray-600);
                  }

                  .ssr-close {
                     opacity: 0;
                     position: absolute;
                     top: 50%;
                     left: 50%;
                     background-color: var(--red-600);
                     transform: translate(-50%, -50%);

                     &::before {
                        transform: translate(-50%, -50%) rotate(-45deg);
                     }

                     &::after {
                        transform: translate(-50%, -50%) rotate(-45deg);
                     }
                  }

                  .ssr-name {
                     font-size: 14px;
                     font-weight: 600;
                     line-height: 1rem;
                  }

                  .ssr-price {
                     font-size: 16px;
                     font-weight: 900;
                     color: var(--blue-800);
                  }
               }

               &.column-hovered {
                  .ssr-button {
                     background-color: #fde8e8;

                     .column-remove-icon {
                        opacity: 1;
                        position: static;
                        transform: none;
                        background-color: var(--red-600);
                     }
                  }
               }
            }
         }
      }
   }

   .total-row {
      display: flex;
      font-weight: 600;
      background-color: var(--gray-100);
      background: #2887d2;
      background: linear-gradient(90deg, rgba(40, 135, 210, 0.125) 0%, rgba(146, 90, 222, 0.125) 100%);
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      .total-label {
         width: $widthOne;
         padding-left: 1rem;
         font-size: 16px;
         color: var(--gray-700);
         display: flex;
         align-items: flex-start;
         gap: 0.5rem;
         padding-top: 0.5rem;

         .gts-icon {
            cursor: pointer;
            font-size: 18px;
            transition: color 0.2s ease;

            &:hover {
               color: var(--blue-600);
            }
         }
      }

      .total-segments {
         display: flex;
         flex-direction: column;
      }

      .total-segment {
         display: flex;

         &.combined {
            .segment-route.combined-label {
               display: flex;
               align-items: center;
               justify-content: center;
               width: $widthTwo;
               border-right: 1px solid var(--gray-200);
               font-weight: 600;
               font-size: 16px;
               color: var(--gray-700);

               .route-label {
                  text-align: center;
               }
            }
         }

         .segment-route {
            @include segment-route-base;
         }

         .ssr-totals {
            display: flex;

            .ssr-total {
               width: $widthThree;

               &.meal {
                  width: $widthThreeMeal;
               }

               display: flex;
               // flex-direction: column;
               align-items: center;
               justify-content: center;
               padding: 0.5rem;
               border-right: 1px dotted gray;

               &:last-child {
                  border-right: none;
               }

               .total-count {
                  display: none;
                  background-color: var(--gray-700);
                  padding: 0.25rem;
                  border-radius: 1rem;
                  font-size: var(--xsmall);
                  margin-right: 0.5rem;
                  color: var(--gray-0);
               }

               .total-price {
                  font-size: 18px;
                  font-weight: 800;
                  color: var(--gray-700);
               }

               .total-empty {
                  min-height: 28px;
                  color: var(--gray-400);
               }
            }
         }
      }
   }
}
</style>
